/** Disjoint rectangles covering the framebuffer exactly once. The interactive
 * rectangle includes whole derivative quads beyond the field's finite support.
 * Emission is multiplied by that same field, so it cannot escape this region.
 */
export function pointerDrawRegions(width, height, cssWidth, cssHeight, x, y, radius) {
    const sx = width / cssWidth;
    const sy = height / cssHeight;
    const left = Math.max(0, 2 * Math.floor(((x - radius) * sx - 4) / 2));
    const bottom = Math.max(0, 2 * Math.floor(((y - radius) * sy - 4) / 2));
    const right = Math.min(width, 2 * Math.ceil(((x + radius) * sx + 4) / 2));
    const top = Math.min(height, 2 * Math.ceil(((y + radius) * sy + 4) / 2));
    if (right <= left || top <= bottom) {
        return { idle: [[0, 0, width, height]], interactive: [0, 0, 0, 0] };
    }
    const idle = [
        [0, 0, width, bottom],
        [0, top, width, height - top],
        [0, bottom, left, top - bottom],
        [right, bottom, width - right, top - bottom],
    ];
    return {
        idle: idle.filter((rect) => rect[2] > 0 && rect[3] > 0),
        interactive: [left, bottom, right - left, top - bottom],
    };
}
//# sourceMappingURL=draw-regions.js.map